import { ERole, ETeamMemberRole, ETeamMemberStatus, ETeamStatus, EUserStatus } from '@app/swagger-types';
import { oneOfEnum } from '@app/utils/yup.utils';
import { InferType, object, string } from 'yup';

export const UserLiteOutDtoSchema = object({
  id: string().defined(),
  firstName: string().nullable(),
  lastName: string().nullable(),
  email: string().defined(),
  role: oneOfEnum(ERole),
  avatarId: string().nullable(),
  status: oneOfEnum(EUserStatus),
  createdDate: string().defined(),
});

export type UserLiteOutDtoSchema = InferType<typeof UserLiteOutDtoSchema>;

export const TeamMemberOutDtoSchema = object({
  id: string().defined(),
  user: UserLiteOutDtoSchema.defined(),
  role: oneOfEnum(ETeamMemberRole),
  status: oneOfEnum(ETeamMemberStatus),
  deletedDate: string().nullable(),
  createdDate: string().defined(),
});

export type TeamMemberOutDtoSchema = InferType<typeof TeamMemberOutDtoSchema>;

export const TeamOutDtoSchema = object({
  id: string().defined(),
  owner: UserLiteOutDtoSchema.defined(),
  status: oneOfEnum(ETeamStatus),
  createdDate: string().defined(),
});

export type TeamOutDtoSchema = InferType<typeof TeamOutDtoSchema>;

export const TeamMemberInDtoSchema = object({
  email: string().email().defined(),
  role: oneOfEnum(ETeamMemberRole),
});

export type TeamMemberInDtoSchema = InferType<typeof TeamMemberInDtoSchema>;
